// One yellow warning per request the customer made about how the replacement
// should ship (see replacementShippingRequest.js). Rendered at the very top of
// the Proposed Steps section. Compact, and at the platform's message-text size
// (MESSAGE_TEXT_SX), in the Alert's own warning text colour.
import { Alert, Box, Typography } from '@mui/material'
import { replacementShippingBanners, inboundWarnings } from './replacementShippingRequest.js'
import { MESSAGE_TEXT_SX } from './constants/typography.js'

const COMPACT_ALERT_SX = {
  py: 0.25,
  px: 1.25,
  mb: 0.5,
  '& .MuiAlert-icon': { fontSize: 18, py: 0.25, mr: 1 },
  '& .MuiAlert-message': { py: 0.25 },
}

export default function ReplacementShippingRequestBanners({ suggestion }) {
  const banners = replacementShippingBanners(suggestion)
  const warnings = inboundWarnings(suggestion)
  if (!banners.length && !warnings.length) return null
  return (
    <Box sx={{ mt: 0.5 }}>
      {/* The 1A Support mailbox's inbound warnings (2026-10-06), same style. */}
      {warnings.map((w) => (
        <Alert key={w} severity="warning" sx={COMPACT_ALERT_SX} data-testid="inbound-warning">
          <Typography sx={MESSAGE_TEXT_SX}>{w}</Typography>
        </Alert>
      ))}
      {banners.map((b) => (b.kind === 'address' ? (
        // The customer's own words for the address stay in the data
        // (b.quote) but are not shown: the address itself says it.
        <Alert key="address" severity="warning" sx={COMPACT_ALERT_SX} data-testid="replacement-address-request">
          <Typography sx={{ ...MESSAGE_TEXT_SX, fontWeight: 600 }}>Customer requested a different shipping address:</Typography>
          {b.lines.map((line, i) => <Typography key={i} sx={MESSAGE_TEXT_SX}>{line}</Typography>)}
          {b.international && (
            <Typography sx={MESSAGE_TEXT_SX}>Not prefilled: international address, enter manually.</Typography>
          )}
        </Alert>
      ) : (
        // The quote is the only place the customer says what they asked for,
        // so it stays.
        <Alert key="expedited" severity="warning" sx={COMPACT_ALERT_SX} data-testid="replacement-expedited-request">
          <Typography sx={MESSAGE_TEXT_SX}>
            <Box component="span" sx={{ fontWeight: 600 }}>Customer requested expedited shipping:</Box>
            {' '}"{b.quote ?? 'faster shipping'}" — shipping method left on the order's method.
          </Typography>
        </Alert>
      )))}
    </Box>
  )
}
